import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10 20h4V4h-4v16zm-6 0h4v-8H4v8zM16 9v11h4V9h-4z"
}), 'EqualizerOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/EqualizerOutlined.js
// module id = 3379
// module chunks = 2